module.exports = __webpack_public_path__ + "static/prafulVijayakar-ee799580b48c5791d0c15c6c65f51c0d.jpg";